import * as apiWorkSpace from '@/api/workspace';
import * as apiAdminWorkSpace from '@/api/admin/workspaces';
import * as apiOrganization from '@/api/organizations';
import store from '@/store';
export default {
    namespaced: true,
    state: {
        historyOrganizations: [],
        workspace: null,
        isFetching: false,
        isFetchingOrganization: false,
        errorMessage: null
    },
    mutations: {
        SET_WORK_SPACE(state, payload) {
            state.workspace = payload;
            state.isFetching = false;
            state.historyOrganizations.splice(0, state.historyOrganizations.length);
        },
        SET_ERROR_MESSAGE(state, payload) {
            state.errorMessage = payload;
        },
        LOADING_WORK_SPACE(state) {
            state.isFetching = true;
            state.errorMessage = null;
        },
        INCREMENT_ORGANIZATION_COUNT(state){
            state.workspace.count_organizations++;
        },
        FETHCING(state){
            state.isFetching = true;
        },
        LOADING_ORGANIZATION(state, {fetch = true}) {
            state.isFetchingOrganization = fetch;
        },
        PUSH_HISTORY_ORGANIZATIONS(state, {id, short_name}){
            let indexDouble = state.historyOrganizations.findIndex(elem => elem.id === id);
            if(-1 !== indexDouble){
                state.historyOrganizations.splice(indexDouble, 1);
            }
            state.historyOrganizations.unshift({id, short_name});
            state.historyOrganizations.splice(6);
        },
        SET_ORGANIZATION(state, payload){
            state.workspace.organization_default = payload;
            state.isFetchingOrganization = false;
        },
    },
    actions: {
        async LEAVE({dispatch, getters}, userId){
            let {data} = await apiWorkSpace.userRemove(getters.ID_WORK_SPACE, userId);
            if("to_work_space_id" in data){
                try{
                    await dispatch('CHECKOUT', data.to_work_space_id);
                    store.dispatch('workspaceList/LOAD_WORKSPACES');
                }catch (e){
                    window.location.reload();
                    console.log(e);
                }
            }
            return data;
        },
        async CHECKOUT_WORKSPACE_ADMIN({dispatch}, workspaceId){
            dispatch('SET_LOADING');
            await apiAdminWorkSpace.show(workspaceId).then((response) => {
                dispatch('SET_WORK_SPACE', response.data.data);
                store.dispatch('notifications/SHOW_SUCCESS', 'Пространство успешно установлено');
            }).catch((err) => {
                dispatch('SET_FETHCING');
                store.dispatch('notifications/SHOW_SUCCESS', 'Ошибка переключения на пространство');
                console.log(err);
            });
        },
        SET_LOADING({ commit }){
            commit('LOADING_WORK_SPACE');
        },
        SET_FETHCING({ commit }){
            commit('FETHCING');
        },
        CLEAR_WORK_SPACE({ commit }){
            commit('SET_WORK_SPACE', null);
        },

        SET_WORK_SPACE({ commit, dispatch, getters}, payload) {
            const isReloadOrgs = getters.ID_WORK_SPACE !== payload.id;
            commit('SET_WORK_SPACE', payload);
            if(isReloadOrgs){
                store.dispatch('organizationList/RELOAD');
            }
            dispatch('SET_ORGANIZATION', payload.organization_default);
        },
        INCREMENT_ORGANIZATION_COUNT({ commit }){
            commit('INCREMENT_ORGANIZATION_COUNT');
        },
        async RELOAD_WORK_SPACE({ dispatch, getters }){
            if(!getters.LOAD_WORK_SPACE){
                Promise.reject('Workspace is not loaded');
            }
            await dispatch('LOAD_WORK_SPACE', getters.ID_WORK_SPACE);
        },
        async CHECKOUT({ dispatch }, workSpaceId){
            await dispatch('LOAD_WORK_SPACE', workSpaceId);
        },
        async CHECKOUT_OTHER_WORKSPACE({ dispatch, commit}) {
            await store.dispatch('workspaceList/LOAD_WORKSPACES');
            const workspaces = store.getters['workspaceList/LIST_WORKSPACES'];
            const workspacesSort = workspaces.filter((workspace) => !workspace.is_current).sort((w1, w2) => w2.is_owner - w1.is_owner);
            if(workspacesSort.length > 0){
                const toWorkSpace = workspacesSort[0];
                return await dispatch('CHECKOUT', toWorkSpace.id);
            }else{
                commit('SET_WORK_SPACE', {name: 'N/A', id: 'ERROR'});
            }
            return Promise.resolve();
        },

        async SELF_LOAD_WORK_SPACE({ dispatch }, wsId){
            try{
                await dispatch('LOAD_WORK_SPACE', wsId);
                return Promise.resolve();
            }catch (e) {
                if(e.response.status === 403){
                    await dispatch('CHECKOUT_OTHER_WORKSPACE');
                    return Promise.resolve();
                }
                return Promise.reject(e);
            }
        },
        async LOAD_WORK_SPACE({ commit, dispatch}, payload){
            try{
                commit('LOADING_WORK_SPACE');
                let result = await apiWorkSpace.load(payload);
                await dispatch('SET_WORK_SPACE', result.data.data);
                return Promise.resolve();
            }catch(e){
                console.log(e);
                commit('SET_ERROR_MESSAGE', 'Ошибка загрузки рабочего пространства');
                store.dispatch('notifications/SHOW_RESPONSE_ERROR', {errorResponse: e, defaultError: 'Ошибка: доступ к пространству ограничен'});
                return Promise.reject(e);
            }
        },
        async RELOAD_ORGANIZATION({ dispatch, getters}){
            dispatch('CHECKOUT_ORGANIZATION', getters.ORGANIZATION_ID);
        },
        async CHECKOUT_ORGANIZATION({ commit, state, dispatch}, payload){
            commit('LOADING_ORGANIZATION', {});
            store.dispatch('organization/SET_FETCH', {fetch: true});
            try{
                let result = await apiOrganization.workspaceOrganizationCheckout(state.workspace.id, payload);
                dispatch('SET_ORGANIZATION', result.data);
            }catch(err){
                store.dispatch('notifications/SHOW_ERROR', 'Ошибка переключения организации');
                console.log(err);
                dispatch('SET_ORGANIZATION', state.workspace.organization_default);
            }
            store.dispatch('organization/SET_FETCH', {fetch: false});
        },
        
        SET_ORGANIZATION({ commit }, payload){
            store.dispatch('organization/SET_ORGANIZATION', payload);
            commit('LOADING_ORGANIZATION', {fetch: false});
            store.dispatch('organizationExecutor/LOAD_EXECUTOR');
            store.dispatch('menu/loadMenu');
        },
    },
    getters: {
        WORKSPACE(state){
            return state.workspace;
        },
        OWNER_USER_ID(state, getters){
            return getters.IS_LOAD_WORK_SPACE ? state.workspace.owner_user_id : null;
        },
        IS_OWNER(state, getters){
            return getters.IS_LOAD_WORK_SPACE ? state.workspace.is_owner : false;
        },
        COUNT_ORGANIZATIONS(state, getters) {
            return getters.IS_LOAD_WORK_SPACE ? state.workspace.count_organizations : 0;
        },
        IS_LOAD_WORK_SPACE(state){
            return state.workspace !== null && ! state.isFetching;
        },
        ID_WORK_SPACE(state, getters){
            return getters.IS_LOAD_WORK_SPACE ? state.workspace.id : null;
        },
        NAME_WORK_SPACE(state, getters){
            return getters.IS_LOAD_WORK_SPACE ? state.workspace.nameSlug : '';
        },
        SHORT_NAME_WORK_SPACE(state, getters){
            if(30 < getters.NAME_WORK_SPACE.length){
                return getters.NAME_WORK_SPACE.substr(0, 30) + '...';
            }
            return getters.NAME_WORK_SPACE;
        },
        ERROR_MESSAGE_WORK_SPACE(state){
            return state.errorMessage;
        },
        ORGANIZATION_HAS(state, getters){
            return getters.IS_LOAD_WORK_SPACE && ! store.getters['organization/IS_EMPTY'];
        },
        ORGANIZATION_ID(){
            return store.getters['organization/ID_ORG'];
        },
        ORGANIZATION_SHORT_NAME(){
            return store.getters['organization/SHORT_NAME'];
        },
        ORGANIZATION_IS_FETCHING(){
            return store.getters['organization/IS_FETCHING'];
        },
        ORGANIZATION_HISTORY(){
            return store.getters['organizationList/ORGANIZATIONS'];
        },
        ORGANIZATION_DEBT_RESULTS_STATUS(){
            return store.getters['organization/DEBT_RESULTS_STATUS'];
        },
        ORGANIZATION_DEBT_RESULTS_CONNECTION_LAST(){
            return store.getters['organization/DEBT_RESULTS_CONNECTION_LAST'];
        },
        ORGANIZATION_DEBT_RESULTS_CONNECTION_EXCHANGE_STATUS(){
            return store.getters['organization/DEBT_RESULTS_CONNECTION_EXCHANGE_STATUS'];
        },
    },
  }